import { FeatureOneData } from "@/data";
import React from "react";
//<i className={icon}></i>
const FeatureOne = () => {
  return (
    <div className="feature_service_area text-center">
      {FeatureOneData.map(({ icon, title }, index) => (
        <div className="feature_service_box_width" key={`feature-one-${index}`}>
            <img src={icon} alt="" className="home-image-feature"/>
          <p className="text-uppercase text-center">{title}</p>
        </div>
      ))}
    </div>
  );
};

export default FeatureOne;
